// Flip Cards (V2) (templates/areas/v2/flip-cards/view.html.twig)
// Klick/Tap/Enter dreht die Karte um; Klick auf die Rückseite (ausser Links) oder der Dreh-Button dreht zurück.
// Mobile: «Mehr anzeigen» blendet die Karten ab der vierten ein. Unabhängig vom v1-Brick «flip-card».
const MOBILE_VISIBLE = 3;

class FlipCards {
  constructor() {
    this.containers = document.querySelectorAll('.js-flip-cards');
  }

  init() {
    this.containers.forEach((container) => this.setup(container));
  }

  setup(container) {
    container.querySelectorAll('[data-flipcard]').forEach((card) => {
      const toggle = card.querySelector('.flipcard-toggle');
      const back = card.querySelector('.flipcard-face.is-back');
      const backButton = card.querySelector('.flipcard-back-button');

      // event.detail === 0: per Tastatur ausgelöst -> Fokus mitnehmen (sonst zeigt Chrome nach Maus/Touch den Fokusrahmen)
      toggle.addEventListener('click', (event) => this.flip(card, true, event.detail === 0));
      backButton.addEventListener('click', (event) => {
        event.stopPropagation();
        this.flip(card, false, event.detail === 0);
      });
      back.addEventListener('click', (event) => {
        if (event.target.closest('a, button')) return;
        this.flip(card, false, false);
      });
    });

    const more = container.querySelector('.flip-cards-more');
    const items = container.querySelectorAll('.flip-cards-item');

    if (more && items.length > MOBILE_VISIBLE) {
      more.hidden = false;
      more.addEventListener('click', (event) => this.toggleMore(container, more, items, event.detail === 0));
    }
  }

  flip(card, open, moveFocus) {
    const front = card.querySelector('.flipcard-face.is-front');
    const back = card.querySelector('.flipcard-face.is-back');
    const toggle = card.querySelector('.flipcard-toggle');

    card.classList.toggle('is-flipped', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    // nur die sichtbare Seite ist bedien- und vorlesbar
    front.inert = open;
    back.inert = !open;

    if (moveFocus) {
      (open ? back : toggle).focus({ preventScroll: true });
    }
  }

  toggleMore(container, more, items, moveFocus) {
    const expanded = !container.classList.contains('is-expanded');

    container.classList.toggle('is-expanded', expanded);
    more.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    more.textContent = expanded ? more.dataset.labelLess : more.dataset.labelMore;

    if (expanded && moveFocus) {
      // Tastatur: weiter mit der ersten neu eingeblendeten Karte
      const firstNew = items[MOBILE_VISIBLE] && items[MOBILE_VISIBLE].querySelector('.flipcard-toggle');

      if (firstNew) firstNew.focus();
    }

    if (!expanded) {
      // die Liste wird kürzer: Button wieder in den sichtbaren Bereich holen
      more.scrollIntoView({ block: 'nearest' });
    }
  }
}

export default new FlipCards();
